import React, { useEffect, useRef, useState } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useDispatch, useSelector } from "react-redux";
import { getSalesAccount } from "../../Redux/Feature/SalesAccount/salesAccountAction";
import {
  getSalesReturn,
  getSalesReturnByMonth,
} from "../../Redux/Feature/SalesReturnAccount/salesReturnAction";
import { Autocomplete, TextField } from "@mui/material";
import { adToBs } from "@sbmdkl/nepali-date-converter";

const drawerWidth = 360;

const SalesReturnTable = ({ TableData }) => {
  const [tableWidth, setTableWidth] = useState("100%");

  useEffect(() => {
    const screenWidth = window.innerWidth;
    const calculatedWidth = screenWidth - drawerWidth;
    setTableWidth(`${calculatedWidth}px`);
  }, []);

  const tableRef = useRef(null);
  const dispatch = useDispatch();

  const token = localStorage.getItem("NHHD:token");

  const { salesReturn, salesReturnByMonth } = useSelector(
    (state) => state.salesReturn
  );
  const { data } = useSelector((state) => state.products);

  const [selectedItem, setSelectedItem] = React.useState(null);

  // Create a map of product IDs to product names
  const productMap = new Map();
  data.forEach((product) => {
    product.purchaseFrom.forEach((purchaseInfo) => {
      productMap.set(purchaseInfo._id, purchaseInfo.productName);
    });
  });

  console.log(productMap);
  // Loop through sale returns and extract product names
  const extractedProductNames = [];
  salesReturnByMonth?.forEach((saleReturn) => {
    saleReturn.particularName.forEach((item) => {
      const productName = productMap.get(item.productId);
      if (productName) {
        extractedProductNames.push(productName);
      }
    });
  });

  console.log(extractedProductNames);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so add 1
  const day = String(today.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;

  const dateInBS = adToBs(formattedDate);

  const monthInBS = parseInt(dateInBS.slice(5, 7)) - 1;
  const yearInBS = dateInBS.slice(0, 4);

  const currentMonthInBS = monthOrder[monthInBS];

  const currentDate = currentMonthInBS + "-" + yearInBS;

  const combinedMonth = salesReturn?.map((item) => {
    return item.saleReturnMonth && item.saleReturnMonth;
  });

  const uniqueSet = new Set(combinedMonth);
  // Convert the Set back to an array to maintain order
  const uniqueMonth = Array.from(uniqueSet);

  const defaultMonthIndex = uniqueMonth.indexOf(currentDate);

  const [selectedMonth, setSelectedMonth] = React.useState(currentDate);

  const handleOptionChange = (event, value) => {
    if (value) {
      console.log("Selected option object:", value);
      setSelectedMonth(value);
    } else {
      // console.log("Selected option cleared");
      setSelectedMonth(null);
    }
  };

  useEffect(() => {
    async function fetch() {
      dispatch(getSalesReturn({ token }));
      dispatch(getSalesReturnByMonth({ token, selectedItem }));
    }
    fetch();
  }, [dispatch, token, selectedItem]);

  return (
    <div className="w-full">
      <div className="w-[300px] my-4 mx-4">
        <Autocomplete
          options={uniqueMonth}
          defaultValue={currentDate}
          value={selectedMonth}
          getOptionLabel={(item) => {
            // console.log("getOptionLabel:", item);
            return item;
          }}
          renderInput={(params) => (
            <TextField {...params} label="Select an option" variant="filled" />
          )}
          onChange={handleOptionChange}
          sx={{ mt: 1 }}
        />
      </div>
      <section class="container p-4 mx-auto " style={{ width: tableWidth }}>
        <p className="text-end">
          {/* <ReactHTMLTableToExcel
            id="purchase-account-table-xls-button"
            className=" text-[green] border  border-[gray]  rounded-[4px] p-2 hover:bg-[green] hover:text-white"
            table="purchase-account-table-to-xls"
            filename="Kharid Khata"
            // sheet="tablexls"
            sheet="Sheet1"
            buttonText="Export to Excel"
          /> */}
          <DownloadTableExcel
            filename="users table"
            sheet="users"
            currentTableRef={tableRef.current}
          >
            <button className=" text-[green] border  border-[gray]  rounded-[4px] p-2 hover:bg-[green] hover:text-white">
              Export to Excel
            </button>
          </DownloadTableExcel>
        </p>

        <div ref={tableRef}>
          <div class="flex flex-col items-center justify-center my-2">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <div class="overflow-hidden md:rounded-lg">
                  <table
                    class="min-w-auto border-collapse"
                    id="purchase-account-table-to-xls"
                  >
                    <tbody class="bg-white">
                      <tr className="flex flex-col items-center">
                        <td
                          className="text-xl font-semibold flex flex-col items-center"
                          colSpan={18}
                        >
                          बिक्री फिर्ता खाता
                        </td>
                      </tr>
                      <tr className="text-md">
                        <td className="text-md" colSpan={18}>
                          (नियम २३ को उपनियम (१) को खण्ड (ज) संग सम्बन्धित )
                        </td>
                      </tr>
                      <tr>
                        <td
                          className="font-medium flex flex-col items-center justify-center"
                          colSpan={18}
                        >
                          <div>करदाता दर्ता नं :hjkl</div>
                          <div>करदाताको नाम :hvjk</div>
                          <div>
                            साल :
                            {selectedItem !== null
                              ? selectedItem?.slice(-4) +
                                "/" +
                                parseInt(parseInt(selectedItem?.slice(-2)) + 1)
                              : null}
                          </div>
                          <div>
                            कर अवधि :
                            {selectedItem !== null
                              ? selectedItem?.replace(/-.*/, "")
                              : null}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-col ">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <div class="overflow-hidden border border-gray-200 md:rounded-lg">
                  <table class="min-w-auto divide-y border-spacing-0 divide-gray-200 ">
                    <thead class="bg-gray-50">
                      <tr>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          colSpan={7}
                        >
                          बीजक
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          rowSpan={2}
                        >
                          जम्मा फिर्ता (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          rowSpan={2}
                        >
                          स्थानीय कर छुटको फिर्ता मूल्य (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-center rtl:text-right text-gray-500"
                          colSpan={2}
                        >
                          करयोग्य फिर्ता
                        </th>
                      </tr>
                      <tr>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          मिति
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          बीजक नं.
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          खरिदकर्ताको नाम
                        </th>

                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          खरिदकर्ताको स्थायी लेखा नम्बर
                        </th>

                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          वस्तु वा सेवाको नाम
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          वस्तु वा सेवाको परिमाण
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          वस्तु वा सेवाको एकाई
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          मूल्य (रु)
                        </th>
                        <th
                          scope="col col-span-5"
                          class="px-[2rem] py-3.5  text-sm font-normal text-left rtl:text-right text-gray-500"
                        >
                          कर (रु)
                        </th>
                      </tr>
                    </thead>

                    <tbody class="bg-white divide-y divide-gray-200    ">
                      {salesReturnByMonth === undefined
                        ? "No product in the list"
                        : salesReturnByMonth?.map((item, i) => {
                            const totalQuantity = item.particularName.map(
                              (item, i) => {
                                return item.productQuantity;
                              }
                            );
                            return (
                              <>
                                <tr key={i}>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item?.saleReturnDate.slice(0, 10)}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item?.saleReturnBillNo}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item?.customerName}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item?.registrationNumber}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{extractedProductNames[0]}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item?.particularName[0]
                                          .productQuantity &&
                                        item?.particularName[0].productQuantity
                                          ? totalQuantity
                                          : "1"}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item?.particularName[0].productSKU}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item?.amountWithTax}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>
                                        {item?.nonTaxableAmount
                                          ? item?.nonTaxableAmount
                                          : "-"}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item?.totalAmountExcludeTax}</span>
                                    </div>
                                  </td>
                                  <td class="px-4 py-4 text-sm font-medium text-gray-700   whitespace-nowrap">
                                    <div class="inline-flex items-center px-4 gap-x-3">
                                      <span>{item?.vatAmount}</span>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                      <tr>
                        <td class="px-4 py-4 text-lg font-semibold text-gray-700   whitespace-nowrap">
                          <div class="inline-flex items-center px-4 gap-x-3">
                            <span>Total:</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SalesReturnTable;

const monthOrder = [
  "बैशाख",
  "जेठ",
  "असार",
  "श्रावण",
  "भाद्र",
  "असोज",
  "कार्तिक",
  "मंसिर",
  "पुष",
  "माघ",
  "फागुन",
  "चैत्र",
];
